import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  isAlarm:false,
  t: 2, //默认地图 1--百度 2--高德
  control: false,//播放控件显示状态
  carMsg: {
    deviceId: "",
    carNum: "",
    userId: '',
    play: 1
  },
  applyAdd:true,//true--添加  false--编辑
  startEndTime:['','']
};

/**
 * mutations 里面放置的是我们操作state对象属性的方法
 */
const mutations = {
  mutationsAddCount(state, n = 0) {
    return (state.count += n);
  },
  mutationsReduceCount(state, n = 0) {
    return (state.count -= n);
  },
  tValue(state, n = 1) {
    return (state.t = n);
  },
  carMsg(state, m, n) {
    return (state.carMsg = {
      deviceNum: m,
      carNum: n
    });
  },
  changeLogin(state, data) {
    return (state.token = data);
  }
};

export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js